// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PlusSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareOutlinedSvg
  }));
};

PlusSquareOutlined.displayName = 'PlusSquareOutlined';
export default React.forwardRef(PlusSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlusSquareOutlined.js
// module id = 3819
// module chunks = 0